import {useLocation} from '@github-ui/react-router'
import {useEffect} from 'react'
import {usePrefersReducedMotion} from '@github-ui/use-prefers-reduced-motion'

/**
 * Scroll to and focus the target element when matched by the URL hash.
 * The element with the matching ID must be focusable.
 */
export function useFocusHashTarget(id: string) {
  const {hash} = useLocation()
  const prefersReducedMotion = usePrefersReducedMotion()
  const targetId = hash.slice(1) // remove leading #

  useEffect(() => {
    if (id === targetId) {
      const element = document.getElementById(id)
      if (!element) return

      element.scrollIntoView({block: 'center', behavior: prefersReducedMotion ? 'auto' : 'smooth'})
      element.focus({
        focusVisible: true,
        preventScroll: true,
      })
    }
  }, [id, prefersReducedMotion, targetId])
}
